import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgDesktop = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.5 4.5v11.413h17V4.5zm11.027 12.913h6.012c.812 0 1.461-.663 1.461-1.467V4.467C22 3.663 21.351 3 20.538 3H3.462C2.649 3 2 3.663 2 4.467v11.479c0 .804.649 1.467 1.462 1.467h6.01L8.646 19.5H7.73a.75.75 0 0 0 0 1.5h8.538a.75.75 0 0 0 0-1.5h-.914zm-1.613 0h-1.828l-.828 2.087h3.484z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgDesktop;
